import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

import 'swiper/css';
import './testimonial.scss';

class TestimonialSlider {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-testimonial-slider',
            sliderAttr: 'main',
            slideAttr: 'slide',
            activeSlideClass: 'is--dragging'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$testimonial = $element;
        this.$testimonialContainer = this.$testimonial.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$testimonialSlides = this.$testimonial.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.testimonialSlider = null;

        if (this.$testimonialContainer && this.$testimonialSlides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        this.initSlider();
        this.addClassOnSlideEvents(['touchStart', 'slideChange', 'autoplay']);
    }

    initSlider () {
        const prevBTN = this.$testimonialContainer.querySelector('.swiper-button-prev');
        const nextBTN = this.$testimonialContainer.querySelector('.swiper-button-next');
        this.testimonialSlider = new Swiper(this.$testimonialContainer, {
            modules: [Navigation, A11y],
            speed: 500,
            effect: 'fade',
            slidesPerView: 1,
            centeredSlides: true,
            a11y: {
                prevSlideMessage: 'Vorheriger Quote',
                nextSlideMessage: 'Nächster Quote'
            },
            navigation: {
                prevEl: prevBTN,
                nextEl: nextBTN,
                addIcons: false,
            }
        });
    }

    addClassOnSlideEvents (events) {
        const swiper = this.testimonialSlider;
        let removeTimer;

        events.forEach((eventName) => {
            swiper.on(eventName, () => {
                const activeSlide = swiper.slides[swiper.activeIndex];
                activeSlide.classList.add(this.settings.activeSlideClass);

                clearTimeout(removeTimer);
                removeTimer = setTimeout(() => {
                    activeSlide.classList.remove(this.settings.activeSlideClass);
                }, 1000);
            });
        });

        swiper.on('slideChange', () => {
            const activeSlide = swiper.slides[swiper.activeIndex];
            activeSlide.classList.remove(this.settings.activeSlideClass);
            clearTimeout(removeTimer);
        });
    }

    destroySlider () {
        if (this.testimonialSlider !== null) {
            this.testimonialSlider.destroy(true, true);
            this.testimonialSlider = null;
        }
    }
}

export { TestimonialSlider };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$TestimonialSlider = $context.querySelectorAll('[data-testimonial-slider="root"]');

        for (let i = 0; i < $$TestimonialSlider.length; i++) {
            const $TestimonialSlider = $$TestimonialSlider[i];
            const TestimonialSliderAPI = new TestimonialSlider($TestimonialSlider);
            $TestimonialSlider.API = TestimonialSliderAPI;
        }
    }
});
